import React, { Fragment, FunctionComponent } from 'react'

import CloudIcon from '@/atoms/icons/cloud.svg'
import { Box, Flex } from '@/atoms/layout'
import { Label } from '@/atoms/typography'
import { Color, Space } from '@/styles'

interface Props {
  title: string
  description: string
}

const ErrorMessage: FunctionComponent<Props> = ({ title, description }) => (
  <Fragment>
    <Box mr={Space.S16}>
      <CloudIcon />
    </Box>
    <Flex flexDirection="column">
      <Label color={Color.ERROR} fontWeight={500}>
        {title}
      </Label>
      <Label>{description}</Label>
    </Flex>
  </Fragment>
)

export default ErrorMessage
